import {
  physicalRoofPlane,
  resolveSolarMounting,
} from '@payaca/helpers/solarMounting';
import {
  parseSolarPlacementRules,
  type SolarPlacementRules,
} from '@payaca/helpers/solarPlacementRules';
import { solarCanonicalJson } from '@payaca/helpers/solarCommittedInputs';
import { type WorkingFace } from './types';

/** Compare only this roof's saved intent with its recorded applied metadata. */
export const selectedLayoutStatus = (
  face: WorkingFace,
  rules?: SolarPlacementRules,
  offset = 0,
  bearingPending = false
) => {
  const parsed = parseSolarPlacementRules(rules);
  const desired = resolveSolarMounting(
    physicalRoofPlane(face),
    face.mounting,
    parsed,
    offset
  );
  const mountingKnown = !!face.roofPlane && face.appliedMounting !== undefined;
  const mounting =
    mountingKnown &&
    (desired.pitchDegrees !== face.pitchDegrees ||
      (desired.onFrames ? 'tilt' : 'flush') !== face.appliedMounting);
  const reference =
    solarCanonicalJson(face.roofEdgeAnchor ?? null) !==
    solarCanonicalJson(face.appliedRoofEdgeAnchor ?? null);
  const spacing =
    !!face.appliedPlacementRules &&
    solarCanonicalJson(face.appliedPlacementRules) !==
      solarCanonicalJson(parsed);
  return {
    mounting,
    mountingKnown,
    referenceKnown: face.appliedRoofEdgeAnchor !== undefined,
    reference,
    spacing,
    bearing: bearingPending,
    pending: mounting || reference || spacing || bearingPending,
  };
};
